import moment from 'moment';
import TransHelper from 'components/common/translations/TransHelper';

class BookingRedirect {

  constructor(props) {
    this.props = props;
    return this;
  }

  checkDateFlight = (flight) => {
    return flight !== null ? !moment().isAfter(flight.flight_date) : true;
  }

  isValidFlightsDate = () => {
    const departureFlight = this.checkDateFlight(this.props.departureFlight);
    const returnFlight = this.checkDateFlight(this.props.returnFlight);
    return departureFlight && returnFlight;
  }

  canViewUserPhoneVerification = () => {
    if (this.props.isLogged ||
      this.props.departureAddress.selectedObject === null) {
      this.redirect();
    }
  }

  canViewKidsSafety = () => {
    if (this.props.childrenNumber === 0) {
      this.redirect();
    }
  }

  canViewFlights = () => {
    if (this.props.startDate.value === null) {
      this.redirect();
    }
  }

  canViewMap = () => {
    if (this.props.departureFlight === null) {
      this.redirect();
    }
  }

  canViewUserData = () => {
    if (!this.props.isLogged && this.props.departureAddress.selectedObject === null) {
      this.redirect();
    }
  }

  canViewSummary = () => {
    if (
      this.props.departureAddress.selectedObject === null ||
      !this.isValidFlightsDate() ||
      this.props.departureFlight === null
    ) {
      this.redirect();
    }
  }

  redirect = () => {
    TransHelper.redirect(this.props, 'routes.url.booking');
  }
}

export default BookingRedirect;
